module.exports = __webpack_public_path__ + "static/img/dragonVRLogo.acff8520.png";